import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, [
    'quantity',
    'downloadVolume',
    'uploadVolume',
    'direction',
  ]);
  let newData = dataModify.replace('{embrixData: ', '');
  newData = `${newData.substring(0, newData.length - 1)}`;
  const updateFileDetailRecord = `updateFileDetailRecord(input: ${newData})`;
  return gql`
  mutation {
    ${updateFileDetailRecord}
  }
`;
};
